import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=5c51ddc6&lang=pug"
import script from "./Checkout.vue?vue&type=script&lang=ts"
export * from "./Checkout.vue?vue&type=script&lang=ts"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=5c51ddc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports